import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <footer className="footer footer-four pt-4">
      {/* Footer Top */}
      <div className="footer-top aos" data-aos="fade-up">
        <div className="container">
          <div className="row">
            {/* Footer Contact */}
       <div className="col-lg-3">
  <div className="footer-contact footer-widget">
    <div className="footer-logo mb-3">
      <img src="/images/logo.jpg" className="img-fluid aos" alt="logo" />
    </div>

    <div className="footer-contact-info">
      <p className="text-white">
       Rising Cab Service offers a variety of vehicles, including hatchbacks, sedans, SUVs, and luxury cars, to ensure a comfortable and hassle-free travel experience for every journey
      </p>

    {/* Business Name & Address */}
<div className="text-white mb-3">
  <h6>
    <i
      className="fas fa-map-marker-alt me-2"
      style={{ color: "#CE8304" }}
    ></i>
    Rising Cab Service
  </h6>

  <p className="mb-0">
    A Unit of Atithya Dining LLP <br />
    901, 902 Deron Height, Baner Rd, <br />
    Above Ranka Jewelers, <br />
    Pune, Maharashtra – 411069
  </p>
</div>

{/* Phone 1 */}
<p className="d-flex align-items-center mb-2">
  <i
    className="fas fa-phone-alt me-2"
    style={{ color: "#CE8304" }}
  ></i>
  <a
    href="tel:+919272511548"
    style={{ color: "#fff", textDecoration: "none" }}
  >
    +91 92725 11548
  </a>
</p>

{/* Phone 2 */}
<p className="d-flex align-items-center mb-2">
  <i
    className="fas fa-phone-alt me-2"
    style={{ color: "#CE8304" }}
  ></i>
  <a
    href="tel:+917796772627"
    style={{ color: "#fff", textDecoration: "none" }}
  >
    +91 77967 72627
  </a>
</p>

{/* Email */}
<p className="d-flex align-items-center mb-2">
  <i
    className="fas fa-envelope me-2"
    style={{ color: "#CE8304" }}
  ></i>
  <a
    href="mailto:booking@risingcabservice.com"
    style={{ color: "#fff", textDecoration: "none" }}
  >
    booking@risingcabservice.com
  </a>
</p>
    </div>


<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2713.5809698580592!2d73.9129627!3d18.5619102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c15a81afc021%3A0x1381bafdd2f10fca!2sLMS%20Finswell!5e1!3m2!1sen!2sin!4v1781103094445!5m2!1sen!2sin" width="100%" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>







    <li className="d-flex gap-3">
              <a href="https://www.instagram.com/risingcab/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61590927445054" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/rising_cab" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/risingcab/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
            </li>
  </div>
</div>

            {/* Footer Menus */}
            <div className="col-lg-9">
              <div className="row">
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
            
<li><Link to="/Pune-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune Darshan Cab</Link></li>
<li><Link to="/Pune-to-Bhimashankar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Bhimashankar Cab</Link></li>
<li><Link to="/Pimpri-Chinchwad-to-Bhimashankar-Cab"><i className="fa fa-car darkcolor"></i> Pimpri Chinchwad to Bhimashankar Cab</Link></li>
<li><Link to="/Pune-to-Jejuri-Cab"><i className="fa fa-car darkcolor"></i> Pune to Jejuri Cab</Link></li>
<li><Link to="/Pune-Weekend-Tour-Packages"><i className="fa fa-car darkcolor"></i> Pune Weekend Tour Packages</Link></li>
<li><Link to="/Pune-Darshan-Packages"><i className="fa fa-car darkcolor"></i> Pune Darshan Packages</Link></li>
<li><Link to="/Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent"><i className="fa fa-car darkcolor"></i> Pune Sade Teen Shakti Peeth Bus on Rent</Link></li>
<li><Link to="/Pune-Darshan-Tempo-Traveller-on-Rent"><i className="fa fa-car darkcolor"></i> Pune Darshan Tempo Traveller on Rent</Link></li>
<li><Link to="/Pune-to-Mysore-Ooty-Cab-Package"><i className="fa fa-car darkcolor"></i> Pune to Mysore Ooty Cab Package</Link></li>
<li><Link to="/Pune-to-Mumbai-Darshan-Package"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Darshan Package</Link></li>
<li><Link to="/Pune-to-Ajanta-Ellora-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Ajanta Ellora Cab Service</Link></li>
<li><Link to="/Pune-to-Shirdi-Darshan-Package"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Darshan Package</Link></li>
<li><Link to="/Pune-to-Pandharpur-Darshan"><i className="fa fa-car darkcolor"></i> Pune to Pandharpur Darshan</Link></li>
<li><Link to="/Hinjewadi-Cab-Service"><i className="fa fa-car darkcolor"></i> Hinjewadi Cab Service</Link></li>
<li><Link to="/Cab-Service-in-Wakad"><i className="fa fa-car darkcolor"></i> Cab Service in Wakad</Link></li>
<li><Link to="/Cab-Service-in-Baner-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Baner Pune</Link></li>
<li><Link to="/Cab-Service-in-Kharadi"><i className="fa fa-car darkcolor"></i> Cab Service in Kharadi</Link></li>
<li><Link to="/Cab-Service-in-Hadapsar"><i className="fa fa-car darkcolor"></i> Cab Service in Hadapsar</Link></li>
<li><Link to="/Cab-Service-in-Viman-Nagar"><i className="fa fa-car darkcolor"></i> Cab Service in Viman Nagar</Link></li>
<li><Link to="/Cab-Service-in-Kothrud"><i className="fa fa-car darkcolor"></i> Cab Service in Kothrud</Link></li>
<li><Link to="/Cab-Service-in-Pimpri-Chinchwad"><i className="fa fa-car darkcolor"></i> Cab Service in Pimpri Chinchwad</Link></li>
<li><Link to="/Cab-Service-in-Wagholi-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Wagholi Pune</Link></li>
<li><Link to="/Pune-to-Trimbakeshwar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Trimbakeshwar Cab</Link></li>
<li><Link to="/Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Cab Service in Pune</Link></li>
<li><Link to="/Outstation-Taxi-Service-Pune"><i className="fa fa-car darkcolor"></i> Outstation Taxi Service Pune</Link></li>
<li><Link to="/Cheap-Cabs-in-Pune"><i className="fa fa-car darkcolor"></i> Cheap Cabs in Pune</Link></li>
<li><Link to="/Pune-Cab-Fare"><i className="fa fa-car darkcolor"></i> Pune Cab Fare</Link></li>
<li><Link to="/Corporate-Cab-Service-Pune"><i className="fa fa-car darkcolor"></i> Corporate Cab Service Pune</Link></li>
<li><Link to="/Pune-Airport-Cabs"><i className="fa fa-car darkcolor"></i> Pune Airport Cabs</Link></li>
<li><Link to="/Pune-Railway-Station-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune Railway Station Cab Service</Link></li>
<li><Link to="/Pune-One-Way-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune One Way Cab Service</Link></li>
<li><Link to="/Pune-Local-and-Outstation-Cab"><i className="fa fa-car darkcolor"></i> Pune Local and Outstation Cab</Link></li>
<li><Link to="/Pune-to-Mumbai-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Cabs</Link></li>
<li><Link to="/Pune-to-Mumbai-Airport-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai Airport Cab</Link></li>
<li><Link to="/Pune-to-Nashik-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Nashik Cab Service</Link></li>
<li><Link to="/Pune-to-Nagpur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Nagpur Cab</Link></li>
                   
                    </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
  <ul>

<li><Link to="/Pune-to-Vidarbha-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Vidarbha Cab Service</Link></li>

<li><Link to="/Pune-to-Kolhapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Kolhapur Cab</Link></li>
<li><Link to="/Pune-to-Solapur-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Solapur Cab Service</Link></li>
<li><Link to="/Pune-to-Ahmednagar-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Ahmednagar Taxi</Link></li>
<li><Link to="/Pune-to-Sangli-Cab"><i className="fa fa-car darkcolor"></i> Pune to Sangli Cab</Link></li>
<li><Link to="/Pune-to-Jalgaon-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Jalgaon Cab Service</Link></li>
<li><Link to="/Pune-to-Thane-Cab"><i className="fa fa-car darkcolor"></i> Pune to Thane Cab</Link></li>
<li><Link to="/Pune-to-Panvel-Cab"><i className="fa fa-car darkcolor"></i> Pune to Panvel Cab</Link></li>
<li><Link to="/Pune-to-Hyderabad-Cab"><i className="fa fa-car darkcolor"></i> Pune to Hyderabad Cab</Link></li>
<li><Link to="/Pune-to-Goa-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Goa Cab Service</Link></li>
<li><Link to="/Pune-to-Sambhaji-Nagar-Aurangabad-Cab"><i className="fa fa-car darkcolor"></i> Pune to Sambhaji Nagar Aurangabad Cab</Link></li>
<li><Link to="/Pune-to-Grishneshwar-Cab"><i className="fa fa-car darkcolor"></i> Pune to Grishneshwar Cab</Link></li>
<li><Link to="/Pune-to-Nanded-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Nanded Cab Service</Link></li>
<li><Link to="/Pune-to-Indore-Cab"><i className="fa fa-car darkcolor"></i> Pune to Indore Cab</Link></li>
<li><Link to="/Pune-to-Ujjain-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ujjain Cab</Link></li>
<li><Link to="/Pune-to-Surat-Cab"><i className="fa fa-car darkcolor"></i> Pune to Surat Cab</Link></li>
<li><Link to="/Pune-to-Ahmedabad-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ahmedabad Cab</Link></li>
<li><Link to="/Pune-to-Lonavala-Cab"><i className="fa fa-car darkcolor"></i> Pune to Lonavala Cab</Link></li>
<li><Link to="/Pune-to-Matheran-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune to Matheran Taxi Service</Link></li>
<li><Link to="/Pune-to-Mahabaleshwar-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Taxi</Link></li>
<li><Link to="/Pune-to-Igatpuri-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Igatpuri Taxi</Link></li>
<li><Link to="/Pune-to-Bangalore-Cab"><i className="fa fa-car darkcolor"></i> Pune to Bangalore Cab</Link></li>
<li><Link to="/Pune-to-Ayodhya-Tour-Package"><i className="fa fa-car darkcolor"></i> Pune to Ayodhya Tour Package</Link></li>
<li><Link to="/Pune-to-Tamhini-Ghat-Cab"><i className="fa fa-car darkcolor"></i> Pune to Tamhini Ghat Cab</Link></li>
<li><Link to="/Pune-to-Shirdi-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Cab</Link></li>
<li><Link to="/Cab-Booking-in-Pune"><i className="fa fa-car darkcolor"></i> Cab Booking in Pune</Link></li>
<li><Link to="/Online-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Online Cab Booking Pune</Link></li>
<li><Link to="/Online-Cab-Booking-in-PCMC-Pune"><i className="fa fa-car darkcolor"></i> Online Cab Booking in PCMC Pune</Link></li>
<li><Link to="/Pune-Outstation-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune Outstation Cab Service</Link></li>
<li><Link to="/Pune-Taxi-Service"><i className="fa fa-car darkcolor"></i> Pune Taxi Service</Link></li>
<li><Link to="/Pune-Cab-Booking"><i className="fa fa-car darkcolor"></i> Pune Cab Booking</Link></li>
<li><Link to="/Best-Cab-Service-in-Pune"><i className="fa fa-car darkcolor"></i> Best Cab Service in Pune</Link></li>
<li><Link to="/Pune-to-Ashtavinayak-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Ashtavinayak Darshan Cab</Link></li>
<li><Link to="/Pune-to-Pandharpur-Tuljapur-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Pandharpur Tuljapur Cabs</Link></li>
<li><Link to="/Pune-to-Akkalkot-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Akkalkot Cab Service</Link></li>
<li><Link to="/Pune-to-Shani-Shingnapur-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shani Shingnapur Cab</Link></li>
<li><Link to="/Pune-to-Shegaon-Cab"><i className="fa fa-car darkcolor"></i> Pune to Shegaon Cab</Link></li>
<li><Link to="/Pune-to-Ganpatipule-Taxi"><i className="fa fa-car darkcolor"></i> Pune to Ganpatipule Taxi</Link></li>


              </ul>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="footer-widget footer-menu">
                    <h5 className="footer-title">Our Services</h5>
                    <ul>
<li><Link to="/Pune-to-Konkan-Darshan-Cab"><i className="fa fa-car darkcolor"></i> Pune to Konkan Darshan Cab</Link></li>

<li><Link to="/Pune-to-Alibag-Cab"><i className="fa fa-car darkcolor"></i> Pune to Alibag Cab</Link></li>
<li><Link to="/Pune-to-Sindhudurg-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Sindhudurg Cab Service</Link></li>
<li><Link to="/Pune-to-Harihareshwar-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Harihareshwar Cabs</Link></li>
<li><Link to="/Pune-to-Diveagar-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Diveagar Cabs</Link></li>
<li><Link to="/Pune-to-Dapoli-Cab"><i className="fa fa-car darkcolor"></i> Pune to Dapoli Cab</Link></li>
<li><Link to="/Pune-to-Guhagar-Cabs"><i className="fa fa-car darkcolor"></i> Pune to Guhagar Cabs</Link></li>
<li><Link to="/Pune-to-Malvan-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune to Malvan Cab Service</Link></li>

<li><Link to="/Mini-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pune</Link></li>
<li><Link to="/Tempo-Traveller-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Tempo Traveller On Rent in Pune</Link></li>
<li><Link to="/Pune-to-Mahabaleshwar-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Mahabaleshwar Tempo Traveller</Link></li>
<li><Link to="/Pune-to-Outstation-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Outstation Tempo Traveller</Link></li>

{/* <li><Link to="/Mini-Bus-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Mini Bus On Rent in Pune</Link></li> */}
<li><Link to="/Outstation-Mini-Bus-on-Rent-Pune"><i className="fa fa-car darkcolor"></i> Outstation Mini Bus on Rent Pune</Link></li>

<li><Link to="/14-Seater-Tempo-Traveller-on-Rent"><i className="fa fa-car darkcolor"></i> 14 Seater Tempo Traveller on Rent</Link></li>
<li><Link to="/17-Seater-Bus-on-Rent-Pune"><i className="fa fa-car darkcolor"></i> 17 Seater Bus on Rent Pune</Link></li>

<li><Link to="/Pune-to-Shirdi-Tempo-Traveller"><i className="fa fa-car darkcolor"></i> Pune to Shirdi Tempo Traveller</Link></li>

<li><Link to="/Luxury-Force-Urbania-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Luxury Force Urbania On Rent in Pune</Link></li>
<li><Link to="/Force-Urbania-Luxury-Mini-Bus-On-Rent"><i className="fa fa-car darkcolor"></i> Force Urbania Luxury Mini Bus On Rent</Link></li>
<li><Link to="/Urbania-On-Rent-Pune"><i className="fa fa-car darkcolor"></i> Urbania On Rent Pune</Link></li>
<li><Link to="/Urbania-on-Rent-in-Pimpri-Chinchwad"><i className="fa fa-car darkcolor"></i> Urbania on Rent in Pimpri Chinchwad</Link></li>

<li><Link to="/Pune-to-5-Jyotirlinga-Cab-Package"><i className="fa fa-car darkcolor"></i> Pune to 5 Jyotirlinga Cab Package</Link></li>
<li><Link to="/Pune-to-Khatu-Shyam-Tour-Package"><i className="fa fa-car darkcolor"></i> Pune to Khatu Shyam Tour Package</Link></li>
<li><Link to="/Pune-to-Jaisalmer-Tour-Package"><i className="fa fa-car darkcolor"></i> Pune to Jaisalmer Tour Package</Link></li>

<li><Link to="/Innova-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Innova On Rent in Pune</Link></li>
{/* <li><Link to="/Online-Cab-Booking-Pune"><i className="fa fa-car darkcolor"></i> Online Cab Booking Pune</Link></li> */}
<li><Link to="/Pune-Airport-Cab-Service"><i className="fa fa-car darkcolor"></i> Pune Airport Cab Service</Link></li>

<li><Link to="/Swift-Dzire-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Swift Dzire On Rent in Pune</Link></li>
<li><Link to="/Sedan-Cabs-Booking-in-Pune"><i className="fa fa-car darkcolor"></i> Sedan Cabs Booking in Pune</Link></li>
<li><Link to="/7-Seater-Car-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 7 Seater Car on Rent in Pune</Link></li>
<li><Link to="/Ertiga-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Ertiga On Rent in Pune</Link></li>

<li><Link to="/Pune-to-Panchgani-Cab"><i className="fa fa-car darkcolor"></i> Pune to Panchgani Cab</Link></li>
<li><Link to="/Rumion-Car-Hire-in-Pune"><i className="fa fa-car darkcolor"></i> Rumion Car Hire in Pune</Link></li>
<li><Link to="/Kia-Carens-On-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> Kia Carens On Rent in Pune</Link></li>

<li><Link to="/32-35-40-45-50-Seater-Bus-on-Rent-in-Pune"><i className="fa fa-car darkcolor"></i> 32,35,40,45,50 Seater Bus on Rent in Pune</Link></li>

<li><Link to="/Pune-to-Mumbai-International-Airport-Cab"><i className="fa fa-car darkcolor"></i> Pune to Mumbai International Airport Cab</Link></li>


           </ul>
                
                
                
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            <div className="row align-items-center row-gap-3 text-center">
              <div className="col-12">
                  <p className="copyright-text text-white">
              All Rights Reserved &copy;  <span className="darkcolorrr">Rising Cab Service</span> <span id="date">{new Date().getFullYear()}</span>{' '}
                <span href="#"> Developed By </span> <a href="https://www.dexterintelligence.com/" className='d-inline' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Dexter Intelligence</span>
              </a> | Hosted By <a href="https://www.urvahosting.com/" className='d-inline ' target="_blank" rel="noopener noreferrer">
                <span className="darkcolorrr">&nbsp;Urva Hosting</span>
              </a>
              </p>
              </div>
              {/* <div className="col-lg-4">
                <div className="payment-list">
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-01.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-02.svg" alt="img" />
                  </a>
                  <a href="javascript:void(0);">
                    <img src="/img/icons/payment-03.svg" alt="img" />
                  </a>
                </div>
              </div> */}
              {/* <div className="col-lg-4">
                <ul className="privacy-link">
                  <li><a href="privacy-policy.html">Privacy</a></li>
                  <li><a href="terms-condition.html">Terms & Condition</a></li>
                  <li><a href="javascript:void(0);">Refund Policy</a></li>
                </ul>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


